"use strict";

exports.__esModule = true;
exports.SessionDVRLive = void 0;
var _SessionSeekable2 = require("../internal/SessionSeekable");
var _DashManifestParser = require("../Parsers/DashManifestParser");
var _Event = require("../internal/Event");
var _HlsManifestParser = require("../Parsers/HlsManifestParser");
var _HttpConnection = require("../Utils/HttpConnection");
var _UrlPoller = require("../internal/UrlPoller");
var _Parser = require("../Parsers/Parser");
var _HttpUtils = require("../Utils/HttpUtils");
var _StringUtils = require("../Utils/StringUtils");
var _YoLog = require("../Utils/YoLog");
var _PlaybackEventHandler = require("./PlaybackEventHandler");
var _Session = require("./Session");
var _CallbackHelper = require("../Utils/CallbackHelper");
var _Constant = require("../Utils/Constant");
var _DefaultPlaybackPolicyHandler = require("../internal/DefaultPlaybackPolicyHandler");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/**
 * Concrete Session implementation representing a single viewing of a single DVR live stream sourced from
 * the Yospace Video Platform via the Central Streaming Manager (CSM)
 * @see {@link Session} base class
 * @hideconstructor
 */
var SessionDVRLive = /*#__PURE__*/function (_SessionSeekable) {
  _inheritsLoose(SessionDVRLive, _SessionSeekable);
  /**
   * 
   * @param {SessionProperties} properties the properties for the Session
   */
  function SessionDVRLive(properties) {
    var _this;
    _this = _SessionSeekable.call(this, properties) || this;

    /** @private */
    _this.streamStart = _Session.INVALID_WINDOW;
    /** @private */
    _this.manifestData = new Map();
    /** @private */
    _this.windowStart = _Session.INVALID_WINDOW;
    /** @private */
    _this.windowEnd = _Session.INVALID_WINDOW;
    /** @private */
    _this.windowSize = _Session.INVALID_WINDOW;
    /** @private */
    _this.pausePoller = null;
    /** @private */
    _this.pauseUrl = "";
    /** @private */
    _this.initialPlayhead = _Session.INVALID_WINDOW;
    /** @private */
    _this.isFallbackLive = false;
    /** @private */
    _this.fallbackPollRequested = false;
    /** @private */
    _this.targetDuration = _Constant.Constant.DEFAULT_POLLING_DELAY;
    _this.setPlaybackPolicyHandler(new _DefaultPlaybackPolicyHandler.DefaultPlaybackPolicyHandler(_Session.PlaybackMode.DVRLIVE));
    return _this;
  }

  /**
   * @callback sessionCallback 
   * @param {SessionDVRLive} session
   */

  /**
   * The factory method for creating a SessionDVRLive instance, when using Direct Initialisation.
   * Constructs and initialises a new SessionDVRLive using the {@link SessionProperties} provided.
   * On completion calls the EventListener provided passing the initialised SessionDVRLive back if
   * a callback was provided.  If a callback was not provided, a Promise is returned instead.
   *
   * @param {string} url The Yospace initialisation URL to the Central Streaming Manager
   * @param {SessionProperties} [properties] (Optional) An initialisation properties object
   * @param {sessionCallback} [callback] (Optional) A completion handler to call after initialisation is finished
   */
  SessionDVRLive.create = function create(url, properties, callback) {
    var session = new SessionDVRLive(properties);
    if (callback) {
      session.initialiseFromSession(url).then(function () {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Session initialised");
      })["catch"](function () {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Session failed to initialise");
      })["finally"](function () {
        callback(new _Event.Event(session));
      });
    } else {
      return session.initialiseFromSession(url);
    }
  };
  var _proto = SessionDVRLive.prototype;
  _proto.initialiseFromSession = function initialiseFromSession(url) {
    var _this2 = this;
    return new Promise(function (resolve, reject) {
      _YoLog.YoLog.trace("sdk init");
      if (!(0, _HttpUtils.getUrl)(url)) {
        _this2.completeWithStatus(_Session.SessionState.FAILED, _Session.MALFORMED_URL);
        reject(_this2);
        return;
      }
      _HttpConnection.HttpConnection.get(url, {
        method: "GET"
      }, _this2.sessionProperties.getRequestTimeout(), _this2.sessionProperties.getCustomHttpHeaders()).then(function (response) {
        if (response.ok) {
          var contentType = response.headers.get("content-type");
          if (contentType && contentType.toLowerCase().includes("application/json")) {
            if (_this2.handleFallbackUrl(response.body)) {
              resolve(_this2);
            } else {
              reject(_this2);
            }
          } else {
            var playerUrl = response.url;
            var payload = _this2.parseManifestResponse(response.body, playerUrl);
            _this2.setPlaybackUrl(playerUrl);
            _this2.initialiseFromPayload(payload);
            if (_this2.getSessionState() !== _Session.SessionState.INITIALISED && _this2.getSessionState() !== _Session.SessionState.NO_ANALYTICS) {
              reject(_this2);
            }
            if (_this2.getSessionState() === _Session.SessionState.INITIALISED) {
              _this2.initialisePoller();
            }
            resolve(_this2);
          }
        } else {
          if (response.timeout) {
            _YoLog.YoLog.e("Primary Url request failed: " + url + ", reason: timeout");
            _this2.completeWithStatus(_Session.SessionState.FAILED, _Session.CONNECTION_TIMEOUT);
          } else {
            _YoLog.YoLog.e("Primary Url request failed: " + url + ", status: " + response.status + ", error: " + response.statusText);
            _this2.completeWithStatus(_Session.SessionState.FAILED, response.status);
          }
          reject(_this2);
        }
      });
    });
  }

  /**
   * @return {number} the duration of the stream
   */;
  _proto.getDuration = function getDuration() {
    return this.windowEnd;
  };
  _proto.getPauseUrl = function getPauseUrl() {
    return this.pauseUrl;
  }

  /**
   * Defines the start point of the DVR Live stream as an epoch time, in seconds. The stream start is the time offset
   * of the first available video segment in the first manifest that is requested by the player.
   * 
   * @return {number} the start point of a DVR Live stream
   */;
  _proto.getStreamStart = function getStreamStart() {
    return this.streamStart;
  }

  /**
   * Returns data from the manifest for the given key. If no key is specified
   * then the entire map is returned.
   * <b>NOTE:</b> Refer to the User Guide for details of the supported data from the manifest.
   * 
   * @param {string} key (Optional) the key
   * @return {Map | number} the requested data, or `undefined` if not present.
   */;
  _proto.getManifestData = function getManifestData(key) {
    if (key) {
      return this.manifestData.get(key);
    }
    return this.manifestData;
  }

  /**
   * Defines the window start of the DVR Live stream, in seconds, as an offset relative to the stream start.
   * The DVR window represents the playable portion of the video stream.
   * 
   * @return {number} the window start point of a DVR Live stream relative to the stream start
   */;
  _proto.getWindowStart = function getWindowStart() {
    return this.windowStart;
  }

  /**
   * Defines the window end of the DVR Live stream, in seconds, as an offset relative to the stream start.
   * The DVR window represents the playable portion of the video stream.
   *
   * @return {number} the window end point of a DVR Live stream relative to the stream start
   */;
  _proto.getWindowEnd = function getWindowEnd() {
    return this.windowEnd;
  }

  /**
   * Defines the window size of a DVR Live stream, in seconds.
   * The DVR window represents the playable portion of the video stream.
   * 
   * @return {number} the window size of a DVR Live stream
   */;
  _proto.getWindowSize = function getWindowSize() {
    return this.windowSize;
  };
  _proto.removeExpiredAdBreaks = function removeExpiredAdBreaks() {
    // if streamStart is not valid, remove any adbreaks that have scrolled beyond the playhead,
    // otherwise remove any adbreaks that have scrolled out of the DVR window.
    // NB: nonlinear and display adbreaks don't expire
    var windowThreshold = this.streamStart === _Session.INVALID_WINDOW ? this.getPlayhead() : this.windowStart;
    var ab = this.getAdBreakForPlayhead(this.getPlayhead());
    for (var i = this.linearAdBreaks.length - 1; i >= 0; i--) {
      var brk = this.linearAdBreaks[i];
      if (brk.getStart() + brk.getDuration() <= windowThreshold) {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Removing ad break.  Start: " + brk.getStart() + "; duration: " + brk.getDuration());
        // If the current adbreak has scrolled out of the window, clean it up.
        // This may happen if the playhead has paused inside an adbreak for a long time.
        if (brk === ab) {
          _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Removing the current adbreak");
          // If there is a current advert, mark it inactive
          var ad = ab.getAdvertFromPlayhead(this.getPlayhead());
          if (ad) {
            ad.setInactive();
          }
          this.onAdvertEnd();
          this.onAdvertBreakEnd();
        }
        this.linearAdBreaks.splice(i, 1);
      }
    }
  }

  /**
   * Shutdown the current Session and release all resources. After this point the state and behaviour
   * is undefined and unsupported. The Session-derived instance must not be used following this call.
   */;
  _proto.shutdown = function shutdown() {
    _SessionSeekable.prototype.shutdown.call(this);

    // Due to JS "Run-to-completion", we don't expect any concurrency issues when shutting down and setting
    // the poller to null
    if (this.analyticPoller) {
      this.analyticPoller.shutdown();
      this.analyticPoller = null;
    }
    if (this.pausePoller) {
      this.pausePoller.shutdown();
      this.pausePoller = null;
    }
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "resources released");
  };
  _proto.getPlaybackMode = function getPlaybackMode() {
    return _Session.PlaybackMode.DVRLIVE;
  };
  _proto.initialisePoller = function initialisePoller() {
    var _this3 = this;
    if (!this.getAnalyticsUrl() || !this.pauseUrl || this.getSessionState() !== _Session.SessionState.INITIALISED) {
      return;
    }
    this.analyticPoller = new _UrlPoller.UrlPoller(this.getAnalyticsUrl(), this.getSessionProperties().getRequestTimeout(), function (response, retry) {
      if (response.status === 400) {
        _this3.onSessionError(_Session.SessionErrorCode.TIMEOUT);
      } else if (response.ok) {
        _this3.targetDuration = retry;
        _this3.parseAnalyticPayload(response.body);
      }
    });
    this.pausePoller = new _UrlPoller.UrlPoller(this.pauseUrl, this.getSessionProperties().getRequestTimeout(), null);
  };
  _proto.hasAnalyticUpdateChanged = function hasAnalyticUpdateChanged(vmap) {
    if (this.getLastAnalyticUpdate() && this.getLastAnalyticUpdate().isEqualTo(vmap)) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Content unchanged.  Analytic update not delivered");
      return false;
    }
    return true;
  };
  _proto.adjustForPdtInitial = function adjustForPdtInitial(vmap) {
    if (this.streamStart === _Session.INVALID_WINDOW) {
      var pdtInitial = vmap.getPdtInitial();
      if (pdtInitial !== null) {
        this.streamStart = pdtInitial;
        if (this.isFallbackLive) {
          _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Received pdtInitial; returning to DVRLive");
          this.isFallbackLive = false;
        }
        if (!this.manifestData.get('availabilityStartTime')) {
          this.manifestData.set('availabilityStartTime', new Date(pdtInitial));
        }
      }
    }
  };
  _proto.handlePdtStartEnd = function handlePdtStartEnd(vmap) {
    var windowMoved = false;
    // Handle PDT start/end
    // If either of these are invalid, don't move the window
    var pdtStart = vmap.getPdtStart();
    var pdtEnd = vmap.getPdtEnd();

    // Note for clarity:
    // this.isFallbackLive === true: Session is in FallbackLive mode; there may never be a DVR window
    // this.streamStart === INVALID_WINDOW: there is no DVR window at the moment
    if (pdtStart !== null && pdtEnd !== null) {
      var pdtStartTime = pdtStart;
      var pdtEndTime = pdtEnd;
      if (this.streamStart === _Session.INVALID_WINDOW) {
        this.streamStart = pdtStartTime;
      }
      var windowStart = pdtStartTime - this.streamStart;
      var windowEnd = pdtEndTime - this.streamStart;
      if (windowStart !== this.windowStart || windowEnd !== this.windowEnd) {
        windowMoved = true;
        this.windowStart = windowStart;
        this.windowEnd = windowEnd;
        this.windowSize = this.windowEnd - this.windowStart;
      }
    } else {
      _YoLog.YoLog.w("PDT start/end value(s) invalid or missing");
    }
    return windowMoved;
  };
  _proto.updateAdBreaks = function updateAdBreaks(vmap) {
    var adbreaks = vmap.getLinearAdBreaks();
    var nadbreaks = vmap.getNonLinearAdBreaks();
    var dabbreaks = vmap.getDisplayAdBreaks();
    var absize = adbreaks.length;
    var nabsize = nadbreaks.length;
    var dabsize = dabbreaks.length;
    Array.prototype.push.apply(this.linearAdBreaks, adbreaks);
    Array.prototype.push.apply(this.nonLinearAdBreaks, nadbreaks);
    if (this.streamStart === _Session.INVALID_WINDOW) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Received " + absize + " linear, " + nabsize + " nonlinear " + dabsize + " display ad breaks");
    } else {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Received: " + absize + " linear, " + nabsize + " nonlinear  " + dabsize + " display ad breaks. New window start: " + this.windowStart + ", end: " + this.windowEnd + " (total: " + this.windowSize + ")");
    }
    this.removeExpiredAdBreaks();
  };
  _proto.parseAnalyticPayload = function parseAnalyticPayload(data) {
    var _this4 = this;
    return _Parser.Parser.parse(data, this).then(function (vmap) {
      if (!vmap) {
        return null;
      }
      if (!_this4.hasAnalyticUpdateChanged(vmap)) {
        return vmap;
      }
      var earlyReturn = vmap.getEarlyReturn();
      if (earlyReturn && earlyReturn !== -1) {
        _this4.adjustForEarlyReturn(earlyReturn);
      }
      _this4.adjustForPdtInitial(vmap);
      if (_this4.isFallbackLive && !vmap.hasAdBreaks()) {
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "FallbackLive: No ad breaks in payload.  Discarding");
      } else {
        var windowMoved = false;
        if (!_this4.isFallbackLive) {
          windowMoved = _this4.handlePdtStartEnd(vmap);
        }
        _this4.updateAdBreaks(vmap);

        // send onAnalyticUpdate() only if mStreamStart is valid and the window has moved,
        // or if there are new ad breaks
        if (_this4.streamStart !== _Session.INVALID_WINDOW && windowMoved || vmap.hasAdBreaks()) {
          _YoLog.YoLog.trace("sdk analytics " + vmap.getLinearAdBreaks().length + " " + vmap.getNonLinearAdBreaks().length + " " + vmap.getDisplayAdBreaks().length + " " + _this4.getDuration());

          // Notify all clients of the new VMAP
          _this4.setLastAnalyticUpdate(vmap);
          _this4.getReportsManager().raiseAnalyticUpdateCallback(_this4);
        }
      }
      return vmap;
    })["catch"](function (err) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_POLLING, "Analytic Poll completed with unreadable data: " + err);
    });
  }

  /**
   * Sets all adverts inactive in all ad breaks prior to the given playhead position. If the playhead
   * is within an advert then that advert is NOT marked as inactive. This method allows client applications
   * to seek to a position before playback begins.
   *
   * @param playhead the playhead position
   */;
  _proto.setAdBreaksInactivePriorTo = function setAdBreaksInactivePriorTo(playhead) {
    for (var _iterator = _createForOfIteratorHelperLoose(this.linearAdBreaks), _step; !(_step = _iterator()).done;) {
      var ab = _step.value;
      if (!ab.setAdvertsInactivePriorTo(playhead)) {
        break;
      }
    }
  };
  _proto.setStreamStart = function setStreamStart(val) {
    this.streamStart = val;
  };
  _proto.parseManifestResponse = function parseManifestResponse(response, url) {
    var playlist = response;
    if (_HlsManifestParser.HlsManifestParser.isHlsManifest(playlist)) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Processing HLS master manifest: " + url);
      return _HlsManifestParser.HlsManifestParser.parse(url, playlist);
    } else {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Processing DASH manifest: " + url);
      return _DashManifestParser.DashManifestParser.parse(playlist);
    }
  };
  _proto.initialiseFromPayload = function initialiseFromPayload(payload) {
    if (!payload) {
      _YoLog.YoLog.e("Unable to process master manifest");
      this.completeWithStatus(_Session.SessionState.NO_ANALYTICS, _Session.UNKNOWN_FORMAT);
    } else if ((0, _StringUtils.isNullOrEmpty)(payload.getAnalyticUrl())) {
      _YoLog.YoLog.e("Analytics URL not found in manifest payload");
      _YoLog.YoLog.w("Playlist/manifest processing unsuccessful");
      this.completeWithStatus(_Session.SessionState.NO_ANALYTICS, 0);
    } else if (!(0, _HttpUtils.getUrl)(payload.getAnalyticUrl())) {
      _YoLog.YoLog.e("Malformed analytics URL in manifest");
      _YoLog.YoLog.w("Playlist/manifest processing unuccessful");
      this.completeWithStatus(_Session.SessionState.NO_ANALYTICS, _Session.MALFORMED_URL);
    } else if (!(0, _HttpUtils.getUrl)(payload.getLocation())) {
      _YoLog.YoLog.e("Player URL is invalid: " + payload.getLocation());
      _YoLog.YoLog.w("Playlist/manifest processing unsuccessful");
      this.completeWithStatus(_Session.SessionState.NO_ANALYTICS, 0);
    } else {
      this.setPlaybackUrl(payload.getLocation());
      if ((0, _StringUtils.isNullOrEmpty)(payload.getPauseUrl())) {
        _YoLog.YoLog.e("Pause URL not found in manifest");
        this.completeWithStatus(_Session.SessionState.NO_ANALYTICS, _Session.NO_DVRLIVE);
      } else if (!(0, _HttpUtils.getUrl)(payload.getPauseUrl())) {
        _YoLog.YoLog.e("Malformed pause URL in manifest");
        this.completeWithStatus(_Session.SessionState.NO_ANALYTICS, _Session.NO_DVRLIVE);
      } else {
        // Success!
        this.setIdentifier(payload.getSessionIdentifier());
        this.setAnalyticsUrl(payload.getAnalyticUrl());
        this.pauseUrl = payload.getPauseUrl();
        this.manifestData.set('availabilityStartTime', payload.getAvailabilityStartTime());
        this.completeWithStatus(_Session.SessionState.INITIALISED, 0);
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_LIFECYCLE, "Successful. Url: " + this.getPlaybackUrl());
      }
    }
  };
  _proto.onPlaybackStart = function onPlaybackStart(playhead) {
    if (!this.isNotPlaying()) {
      _YoLog.YoLog.w("Reporting START when start has already been reported");
    } else if (this.getSessionState() !== _Session.SessionState.INITIALISED) {
      _YoLog.YoLog.w("Reporting START when session is not initialised");
    } else if (this.analyticPoller) {
      _SessionSeekable.prototype.onPlaybackStart.call(this, playhead);
      this.initialPlayhead = playhead;
      this.analyticPoller.start();
    }
  };
  _proto.onPlaybackReady = function onPlaybackReady() {
    // Handles any error messages
    _SessionSeekable.prototype.onPlaybackReady.call(this);
    if (this.getSessionState() === _Session.SessionState.INITIALISED && this.playing !== true) {
      if (this.analyticPoller) {
        this.analyticPoller.poll();
      }
    }
  };
  _proto.onPlaybackPause = function onPlaybackPause() {
    if (!this.isNotPlaying()) {
      if (this.pausePoller && this.getSessionState() === _Session.SessionState.INITIALISED) {
        this.pausePoller.start();
      }
    }
    _SessionSeekable.prototype.onPlaybackPause.call(this);
  };
  _proto.onPlaybackResume = function onPlaybackResume() {
    if (this.isNotPlaying()) {
      if (this.pausePoller) {
        this.pausePoller.stop();
      }
    }
    _SessionSeekable.prototype.onPlaybackResume.call(this);
  };
  _proto.onPlayerEvent = function onPlayerEvent(event, playhead) {
    // Any non-linear playhead change must set didSeek
    if (event === _PlaybackEventHandler.PlayerEvent.SEEK || event === _PlaybackEventHandler.PlayerEvent.ADVERT_SKIP || event === _PlaybackEventHandler.PlayerEvent.ADVERT_REWIND) {
      this.didSeek = true;
    }
    _SessionSeekable.prototype.onPlayerEvent.call(this, event, playhead);
  };
  _proto.onPlayheadUpdate = function onPlayheadUpdate(playhead) {
    // If the DVR window is not yet valid, execute a 'recovery' poll after half the target segment length
    // Drop into FallbackLive if no PDT data is received within the target segment length.
    if (this.streamStart === _Session.INVALID_WINDOW && !this.isFallbackLive) {
      if (this.analyticPoller && this.analyticPoller.isRunning()) {
        if (playhead >= this.initialPlayhead + this.targetDuration) {
          _YoLog.YoLog.w("Did not receive pdtStart/End within " + this.targetDuration + "ms; going into FallbackLive");
          this.isFallbackLive = true;
        } else if (playhead >= this.initialPlayhead + this.targetDuration / 2) {
          if (!this.fallbackPollRequested) {
            _YoLog.YoLog.w("Did not receive pdtStart/End after " + playhead + "ms; polling again");
            this.fallbackPollRequested = true;
            this.analyticPoller.poll();
          }
        }
      }
    }
    this.handleHeartbeat(playhead);
    _SessionSeekable.prototype.onPlayheadUpdate.call(this, playhead);
  };
  _proto.canPause = function canPause() {
    return this.streamStart !== _Session.INVALID_WINDOW && _SessionSeekable.prototype.canPause.call(this);
  };
  _proto.canSkip = function canSkip() {
    if (this.streamStart === _Session.INVALID_WINDOW) {
      return -1;
    } else if (this.policyHandler) {
      var ret = (0, _CallbackHelper.raiseCallback)(this.policyHandler, this.policyHandler.canSkip, this.getPlayhead(), this.linearAdBreaks, this.getDuration());
      if (ret === null) {
        ret = this.defaultPolicyHandler.canSkip(this.getPlayhead(), this.linearAdBreaks, this.getDuration());
      }
      return ret;
    } else {
      return 0;
    }
  };
  _proto.willSeekTo = function willSeekTo(position) {
    return this.streamStart === _Session.INVALID_WINDOW ? this.getPlayhead() : _SessionSeekable.prototype.willSeekTo.call(this, position);
  };
  return SessionDVRLive;
}(_SessionSeekable2.SessionSeekable);
exports.SessionDVRLive = SessionDVRLive;